module.exports = __webpack_public_path__ + "staticVue/img/financial.ac0519f4.png";